import ChecklistLayout from "../../Componentes/ChecklistLayout";
import Comentarios from "../../Componentes/Comentarios";
import Checklists from "../../Componentes/Checklist";

import pdf from "../../assets/Data Discovery, Olap e visualização de dados.pdf"

function Checklist() {

    return (
        <>
            <ChecklistLayout
                leftContent={
                    <iframe
                        title="Arquivo"
                        src={`${pdf}#navpanes=0&zoom=page-fit`}
                        width="100%"
                        height="700px"
                        loading="lazy"
                        referrerPolicy="no-referrer"
                        allowFullScreen
                    />
                }
                middleContent={
                    <Checklists />
                }
                rightContent={
                    <Comentarios />
                }
            />
        </>
    );
}

export default Checklist;
